import { render, staticRenderFns } from "./LamboDigitalColumn.vue?vue&type=template&id=9930ce02&scoped=true&"
import script from "./LamboDigitalColumn.vue?vue&type=script&lang=js&"
export * from "./LamboDigitalColumn.vue?vue&type=script&lang=js&"
import style0 from "./LamboDigitalColumn.vue?vue&type=style&index=0&id=9930ce02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9930ce02",
  null
  
)

export default component.exports